import type { CSSProperties, ReactNode } from 'react';
import * as Select from '@radix-ui/react-select';
import { ChevronDownIcon, ChevronUpIcon } from '@radix-ui/react-icons';
import { FlexColumn } from '~/components/atoms/container';
import { SelectItem } from '~/components/atoms/select';

type CustomSelectItem = {
  id: string;
  label: ReactNode;
  value: string;
  disabled?: boolean;
};

export type CustomSelectProps = {
  name: string;
  label?: ReactNode;
  title?: ReactNode;
  data: CustomSelectItem[];
  style?: CSSProperties;
  placeholder?: string;
  defaultValue?: string;
  children?: ReactNode;
  disabled?: boolean;
  required?: boolean;
  onChange?: (value: string) => void;
};

export function CustomSelect({
  label,
  name,
  title,
  data,
  style,
  placeholder,
  defaultValue,
  children,
  disabled,
  required,
  onChange
}: CustomSelectProps) {
  return (
    <FlexColumn style={style}>
      {label}

      <Select.Root
        name={name}
        defaultValue={defaultValue}
        disabled={disabled}
        onValueChange={onChange}
        required={required}
      >
        <Select.Trigger className="form__select-trigger" aria-label="Role">
          <Select.Value placeholder={placeholder} />

          <Select.Icon className="form__select-icon">
            <ChevronDownIcon />
          </Select.Icon>
        </Select.Trigger>

        <Select.Portal>
          <Select.Content className="form__select-content">
            <Select.ScrollUpButton className="form__select-scroll-btn">
              <ChevronUpIcon />
            </Select.ScrollUpButton>

            <Select.Viewport className="form__select-viewport">
              <Select.Group>
                {title ? (
                  <Select.Label
                    className="form__select-label"
                    children={title}
                  />
                ) : null}

                {data?.map(item => (
                  <SelectItem
                    key={item.id}
                    value={item.value}
                    children={item.label}
                    disabled={item.disabled}
                  />
                ))}
              </Select.Group>
            </Select.Viewport>
          </Select.Content>
        </Select.Portal>
      </Select.Root>

      {children}
    </FlexColumn>
  );
}
